module.exports = __webpack_public_path__ + "static/media/ico_horario_new.396e4c18.svg";